// extracted by mini-css-extract-plugin
export var container = "FeaturedLinks-module--container--96d54";
export var keyLink = "FeaturedLinks-module--keyLink--ff997";
export var link = "FeaturedLinks-module--link--71123";
export var moreLinks = "FeaturedLinks-module--moreLinks--81d44";